var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Environment, HttpMethod, HttpResponseMockType, Service } from '../../enums';
import { getEnvironment } from '../../utils/domain';
import { sleep } from '../../utils/helpers';
import { createClient } from './client';
import { getServiceBaseURL, getServiceTimeout } from './services';
const IS_TEST_ENV = process.env.NODE_ENV === 'test';
const IS_MOCK_ENABLED = process.env.NEXT_PUBLIC_ENVIRONMENT_ENABLE_BACKEND_MOCK === 'true';
const CLIENTS = Object.values(Service).reduce((acc, service) => {
    acc[service] = createClient(getServiceBaseURL(service), getServiceTimeout(service));
    return acc;
}, {});
const shouldMockResponse = (mock) => {
    var _a;
    if (!mock || mock.disabled || !(IS_MOCK_ENABLED || IS_TEST_ENV))
        return false;
    return ((_a = mock.environments) !== null && _a !== void 0 ? _a : [Environment.Local]).includes(getEnvironment());
};
export const createHttpAction = (request, mock) => __awaiter(void 0, void 0, void 0, function* () {
    if (shouldMockResponse(mock)) {
        const { error, type, delay, data, headers, status } = mock || {};
        if (!IS_TEST_ENV)
            yield sleep(delay);
        if (type === HttpResponseMockType.REJECT) {
            return Promise.reject(error);
        }
        else {
            return Promise.resolve({ data, headers, status });
        }
    }
    const { service, url, method, data, settings } = request;
    if (!(service && url)) {
        throw new Error('Missing required parameter when calling "createHttpAction"');
    }
    const action = method !== null && method !== void 0 ? method : HttpMethod.GET;
    let requestSettings = settings || {};
    // GET, DELETE (actions without payload)
    if ([HttpMethod.GET, HttpMethod.DELETE].includes(action)) {
        return CLIENTS[service][action.toLowerCase()](url, requestSettings);
    }
    // POST, PUT, PATCH  (actions with payload)
    return CLIENTS[service][action.toLowerCase()](url, data, requestSettings);
});
//# sourceMappingURL=action.js.map